import * as maptalks from 'maptalks'
import { ThreeLayer } from 'maptalks.three'

export const createBaseLayer = (url) => new maptalks.TileLayer('base', {
  urlTemplate: url,
  crossOrigin: 'Anonymous',
  subdomains: ['a', 'b', 'c', 'd'],
  attribution: 'PlayMetrix-GPS'
})

export const createMap = ({ id, options }) => new maptalks.Map(id, {
  baseLayer: createBaseLayer('http://b.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png'),
  ...options
})

export const createVectorLayer = ({ name = 'vector', options }) => new maptalks.VectorLayer(name, options)

export const createThreeLayer = ({ name = 'three' }) => new ThreeLayer(name)

export const createLineLayer = ({ coordinates, options }) => new maptalks.LineString(coordinates, options)

export const createLabel = ({ label, coordinates, options }) => new maptalks.Label(label, coordinates, options)

export const createMarker = ({ coordinates, options }) => new maptalks.Marker(coordinates, options)
